@if (!item.disabled) {
  <div
    class="card home-card"
    [routerLink]="['/' + item.url]">
    <div class="card-header">
      <h4 class="card-title">
        <love-it-generic-icon [selector]="item.icon"></love-it-generic-icon>
        {{ item.title }}
      </h4>
    </div>
    <div class="card-body pb-1">
      <p class="card-text">{{ item.description }}</p>
    </div>
  </div>
}
